<template>
  <div>
    <div
      class="d-flex gap-2"
    >
      <b-skeleton
        width="42px"
        height="42px"
        type="avatar"
      />
      <div class="d-flex flex-column flex-grow-1">
        <div
          class="d-flex justify-content-between p-1 px-2"
        >
          <div class="font-weight-bold">
            <b-skeleton width="100px" />
          </div>

          <div class="small">
            <b-skeleton width="100px" />
          </div>
        </div>

        <b-card
          body-class="py-2 px-2"
          :class="['border']"
        >

          <b-card-text>
            <div class="d-flex flex-column">
              <div class="py-2">
                <b-skeleton width="90%" />
                <b-skeleton width="100%" />
                <b-skeleton width="80%" />
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OtherCommentSkeleton'
}
</script>
